/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: eventOptions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the ESL Users module.
────────────────────────────────────────────────────────────────*/


export const FS_EVENT_TYPES: string[] = [
  'ADD_SCHEDULE',
  'API',
  'BACKGROUND_JOB',
  'CALL_DETAIL',
  'CALL_SECURE',
  'CALL_SETUP_REQ',
  'CALL_UPDATE',
  'CDR',
  'CHANNEL_ANSWER',
  'CHANNEL_APPLICATION',
  'CHANNEL_BRIDGE',
  'CHANNEL_CALLSTATE',
  'CHANNEL_CREATE',
  'CHANNEL_DATA',
  'CHANNEL_DESTROY',
  'CHANNEL_EXECUTE',
  'CHANNEL_EXECUTE_COMPLETE',
  'CHANNEL_GLOBAL',
  'CHANNEL_HANGUP',
  'CHANNEL_HANGUP_COMPLETE',
  'CHANNEL_HOLD',
  'CHANNEL_ORIGINATE',
  'CHANNEL_OUTGOING',
  'CHANNEL_PARK',
  'CHANNEL_PROGRESS',
  'CHANNEL_PROGRESS_MEDIA',
  'CHANNEL_STATE',
  'CHANNEL_UNBRIDGE',
  'CHANNEL_UNHOLD',
  'CHANNEL_UNPARK',
  'CHANNEL_UUID',
  'CLONE',
  'CODEC',
  'COMMAND',
  'CONFERENCE_DATA',
  'CONFERENCE_DATA_QUERY',
  'CUSTOM',
  'DEL_SCHEDULE',
  'DETECTED_SPEECH',
  'DETECTED_TONE',
  'DEVICE_STATE',
  'DTMF',
  'EXE_SCHEDULE',
  'FAILURE',
  'GENERAL',
  'HEARTBEAT',
  'LOG',
  'MEDIA_BUG_START',
  'MEDIA_BUG_STOP',
  'MESSAGE',
  'MESSAGE_QUERY',
  'MESSAGE_WAITING',
  'MODULE_LOAD',
  'MODULE_UNLOAD',
  'NAT',
  'NOTALK',
  'NOTIFY',
  'NOTIFY_IN',
  'PHONE_FEATURE',
  'PHONE_FEATURE_SUBSCRIBE',
  'PLAYBACK_START',
  'PLAYBACK_STOP',
  'PRESENCE_IN',
  'PRESENCE_OUT',
  'PRESENCE_PROBE',
  'PRIVATE_COMMAND',
  'PUBLISH',
  'QUEUE_LEN',
  'RECORD_START',
  'RECORD_STOP',
  'RECV_INFO',
  'RECV_MESSAGE',
  'RECV_RTCP_MESSAGE',
  'RECYCLE',
  'RELOADXML',
  'REQUEST_PARAMS',
  'RE_SCHEDULE',
  'ROSTER',
  'SEND_INFO',
  'SEND_MESSAGE',
  'SESSION_HEARTBEAT',
  'SHUTDOWN',
  'STARTUP',
  'SUBCLASS_ANY',
  'TALK',
  'TRAP',
  'UNPUBLISH'
];

export const FS_CUSTOM_EVENT_SUBCLASSES: string[] = [
  'alsa::ringing',
  'bert::in_sync',
  'bert::lost_sync',
  'bert::timeout',
  'callcenter::info',
  'conference::cdr',
  'conference::maintenance',
  'cv::video_detect',
  'dingaling::connected',
  'dingaling::login_failure',
  'dingaling::login_success',
  'fifo::info',
  'filestring::close',
  'filestring::fail',
  'filestring::open',
  'freeswitchc::boot_freeswitch',
  'gsmopen::alarm',
  'gsmopen::dump_event',
  'gsmopen::incoming_sms',
  'khomp::maintenance',
  'khomp::sms_received',
  'khomp::sms_sent',
  'limit::usage',
  'menu::enter',
  'menu::exit',
  'multicast::event',
  'multicast::peerdown',
  'multicast::peerup',
  'name::method_name',
  'parking::info',
  'portaudio::audio_dev_error',
  'portaudio::callheld',
  'portaudio::callresumed',
  'portaudio::makecall',
  'portaudio::ringing',
  'rtmp::attach',
  'rtmp::clientcustom',
  'rtmp::connect',
  'rtmp::custom',
  'rtmp::detach',
  'rtmp::disconnect',
  'rtmp::login',
  'rtmp::logout',
  'rtmp::register',
  'rtmp::unregister',
  'sendfile::ack',
  'skinny::alarm',
  'skinny::call_state',
  'skinny::device_to_user',
  'skinny::expire',
  'skinny::register',
  'skinny::unregister',
  'skinny::user_to_device',
  'skypopen::incoming_chatmessage',
  'skypopen::incoming_raw',
  'smpp::bind_transceiver_resp',
  'sofia::error',
  'sofia::expire',
  'sofia::gateway_add',
  'sofia::gateway_delete',
  'sofia::gateway_state',
  'sofia::intercepted',
  'sofia::notify_refer',
  'sofia::notify_watched_header',
  'sofia::pre_register',
  'sofia::profile_start',
  'sofia::recovery_recovered',
  'sofia::recovery_recv',
  'sofia::recovery_send',
  'sofia::register',
  'sofia::register_attempt',
  'sofia::register_failure',
  'sofia::reinvite',
  'sofia::replaced',
  'sofia::sip_user_state',
  'sofia::transferee',
  'sofia::transferor',
  'sofia::unregister',
  'sofia::wrong_call_state',
  'spandsp::rxfaxnegociateresult',
  'spandsp::rxfaxpageresult',
  'spandsp::rxfaxresult',
  'spandsp::txfaxnegociateresult',
  'spandsp::txfaxpageresult',
  'spandsp::txfaxresult',
  'test::cool',
  'unimrcp::profile_close',
  'unimrcp::profile_create',
  'unimrcp::profile_open',
  'verto::client_connect',
  'verto::client_disconnect',
  'verto::login',
  'vmd::beep',
  'vm::maintenance'
];

export const FREE_SWITCH_EVENTS: string[] = [
  ...FS_EVENT_TYPES,
  ...FS_CUSTOM_EVENT_SUBCLASSES
];


